// Pure navigation math for the Cadence rule wizard stepper.
// No React, no side effects — unit-tested in cadenceWizardNav.test.ts.

export type SectionStatus = 'saved' | 'partial' | 'unsaved';

/** Last stage number. New (uncreated) rule stops at 6 (Dates & Parameters);
 *  once the rule exists (edit), the Versions stage (7) is reachable. */
export const NEW_RULE_LAST_STAGE = 6;
export const EDIT_RULE_LAST_STAGE = 7;

export function lastStage(isEdit: boolean): number {
  return isEdit ? EDIT_RULE_LAST_STAGE : NEW_RULE_LAST_STAGE;
}

export function isFirstStage(current: number): boolean {
  return current <= 1;
}

export function isLastStage(current: number, isEdit: boolean): boolean {
  return current >= lastStage(isEdit);
}

export function clampStage(target: number, isEdit: boolean): number {
  return Math.max(1, Math.min(target, lastStage(isEdit)));
}

/** For a brand-new (uncreated) rule, only Identity (1) and Authority (2) are
 *  reachable — they create the rule header. Stages 3+ need a rule_id, so they
 *  stay locked until the rule exists. Once editing, nothing is locked. */
export function isBubbleLocked(target: number, isEdit: boolean): boolean {
  if (isEdit) return false;
  return target > 2;
}
